import styled from 'styled-components';

import { size, rem } from '../layout/helpers';
import { theme } from '../layout/theme';

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${theme.colors.badge.sale};
  color: ${theme.colors.text.onColor};
  padding: ${size(0.5)} ${size(1.5)};
  font-size: ${rem(12)};
  font-weight: 600;
  line-height: 1;
  position: relative;
  width: 100%;

  &.border-radius {
    border-radius: 99px;
  }

  &.auto-width {
    width: auto;
  }

  &.large {
    font-size: ${rem(14)};
    padding: ${size(1)} ${size(1.5)};
    display: inline-flex;
    justify-content: space-between;
  }

  ${theme.screens.Md} {
    &.large {
      font-size: ${rem(16)};
      padding: ${size(1)} ${size(2)};
    }
  }

  &.product-card {
    width: auto;
    align-items: center;
    padding: ${size(0.5)} ${size(1)};

    ${theme.screens.Sm} {
      height: ${size(4)};
      padding: ${size(0.75)} ${size(1.5)};
      font-size: 1rem;
    }
  }

  &.cart {
    height: ${size(3)};
    font-size: 13px;
  }

  &.tone-highlight {
    background-color: ${theme.colors.badge.highlight};
    color: ${theme.colors.text.onColor};
  }

  &.collapsed {
    border-radius: 0;
  }

  &.collapsed-mobile {
    ${theme.screens.LtMd} {
      border-radius: 0;
      margin-left: ${size(-2)};
      margin-right: ${size(-2)};
      width: calc(100% + ${size(4)});
      padding-left: ${size(2)};
      padding-right: ${size(2)};
    }
  }

  &.collapsed-desktop {
    ${theme.screens.Md} {
      border-radius: 0;
      margin-left: ${size(-2)};
      margin-right: ${size(-2)};
      width: calc(100% + ${size(4)});
      padding-left: ${size(2)};
      padding-right: ${size(2)};
    }
  }

  &.fit-to-content {
    border-radius: 99px;
    margin: auto;
    width: auto;
  }

  &.default-color-scheme {
    background-color: #e36500;
    color: #ffff;
  }
`;

export const Text = styled.div`
  .product-card & {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
`;

export const Tail = styled.div`
  font-weight: 400;
  display: inline-block;
  vertical-align: baseline;
  margin-left: ${size(0.5)};
`;

export const ReadMore = styled.button`
  margin-left: ${size(0.5)};
  position: static;
  font: inherit;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
